/* eslint-disable */

export enum DealStatus {
  /** UNKNOWN_DEAL_STATUS - set a default value */
  UNKNOWN_DEAL_STATUS = "UNKNOWN_DEAL_STATUS",
  /**
   * DEAL_DISABLED - Logically indicates a deal that exists in our system that should not yet be displayed, but
   * probably will be active in the future. Present usage is for unactivated boosts.
   */
  DEAL_DISABLED = "DEAL_DISABLED",
  DEAL_ACTIVE = "DEAL_ACTIVE",
  DEAL_DELETED = "DEAL_DELETED",
}

export interface Deal {
  business_token?: string;
  deal_token?: string;
  description?: string;
  url?: string;
  start_time_ms?: number;
  end_time_ms?: number;
  status?: DealStatus;
  version?: number;
  deal_type?: DealDealType;
  offerly_token?: string;
}

export enum DealDealType {
  AFTERPAY = "AFTERPAY",
  REWARDLY_BOOST = "REWARDLY_BOOST",
}

export interface UpsertDealRequest {
  deal?: Deal;
}

export interface UpsertDealResponse {
  deal?: Deal;
}
